/* smellBgone — add-to-cart from the bundles listing.

   Every bundle is a single Default Title variant, so there is nothing to choose
   and sending someone to the product page to press one button is a step for its
   own sake. The markup is a real <form> POSTing to /cart/add, so with no
   JavaScript it still works — it just navigates to /cart afterwards, which is
   Shopify's own behaviour. This upgrades it to an AJAX add so the shopper keeps
   their place in the row.

   Deliberately its own file rather than an inline <script>: the Section
   Rendering API does not re-execute inline scripts, so an inline version would
   be dead the moment the theme editor re-rendered the section — the exact bug
   that killed the shop-all filters. It also listens on `document` rather than
   binding per form, so cards that arrive from a re-render are handled with no
   re-initialisation at all.

   On any failure it falls back to submitting the form normally. A cart add that
   silently does nothing is worse than one that navigates.

   AFTER THE ADD, THE DRAWER IS RE-RENDERED AND OPENED. It used to only patch
   the [data-cart-count] badge. The drawer's contents are server-rendered once,
   at page load — so after an add they still showed the cart as it was BEFORE
   it, usually empty, and the only way to see what you had just bought was to
   reload the page. That is the bug Dave reported on the bundles page. The PDP
   form has always done this (smb-product.js); this is the same call, so the two
   add-to-cart paths behave identically. smbCartDrawer is published by
   smb-cart-drawer.js, which the header loads on every page — if it is somehow
   absent (JS error, drawer markup removed) the badge-only path below still
   runs, so the add is never left invisible. */
(function () {
  'use strict';

  var RESET_MS = 1600;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      // The header hides a zero badge; unhide it once there is something in it.
      if (n > 0) el.hidden = false;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bundle-add]');
    if (!form) return;
    if (!window.fetch) return; // legacy browser: let the form POST normally

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.querySelector('.smb-btn-label') || btn : null;
    if (btn && btn.disabled) return;

    var id = form.querySelector('input[name="id"]');
    if (!id || !id.value) {
      form.submit();
      return;
    }

    // innerHTML, not textContent: where the label is the button itself its
    // cart icon is part of it, and restoring plain text would drop it.
    var previous = label ? label.innerHTML : '';
    // Tracked so the failure path below can tell "the add never happened" from
    // "the add worked and something after it did not". Re-posting the form in
    // the second case would put the bundle in the cart twice.
    var added = false;
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id.value, quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        added = true;
        // Pull the drawer's real content in, then open it. Without this the
        // drawer keeps the markup it was server-rendered with at page load, so
        // it shows the cart as it stood before this add until a full reload.
        if (window.smbCartDrawer) {
          return window.smbCartDrawer.refresh().then(window.smbCartDrawer.open);
        }
        return fetch('/cart.js')
          .then(function (r2) {
            return r2.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
          });
      })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        if (btn) btn.classList.add('is-added');
        setTimeout(function () {
          if (label) label.innerHTML = previous;
          if (btn) {
            btn.classList.remove('is-added');
            btn.disabled = false;
          }
        }, RESET_MS);
      })
      .catch(function () {
        // Never leave the button stuck.
        if (btn) btn.disabled = false;
        if (label) label.innerHTML = previous;
        // The add itself failed: hand the shopper back to the plain form post,
        // which lands them on /cart with the item added. If the add HAD already
        // gone through, reload instead — re-posting would buy it twice.
        if (added) window.location.reload();
        else form.submit();
      });
  });
})();
